// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

//bas
// const firebaseConfig = {
//   apiKey: "AIzaSyAbNWXpLfzwX_sbMQMni9g8gID3IKGvALQ",
//   authDomain: "org-booking.firebaseapp.com",
//   projectId: "org-booking",
//   storageBucket: "org-booking.firebasestorage.app",
//   messagingSenderId: "575452975788",
//   appId: "1:575452975788:web:a902af31261d6328ba0509",
//   measurementId: "G-C80KWR3L2D",
// };

//ying
const firebaseConfig = {
  apiKey: "AIzaSyD-j9EkKaJbso0X-gHzNGfAJ7ZlY8jseg0",
  authDomain: "org-booking-4872d.firebaseapp.com",
  projectId: "org-booking-4872d",
  storageBucket: "org-booking-4872d.firebasestorage.app",
  messagingSenderId: "104399312761",
  appId: "1:104399312761:web:1044e877a94f5f6c66c1a8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

